<template>
  <div class="index">
    <div class="nav" v-if="!$isMobile">
      <div class="navLeft">
        <img class="logo" @click="gotoJKQY" src="../assets/images/logo.png" />
        <div
          :class="['itemName', 'toolNav', { mobileFontSize: $isMobile }]"
          @click="gotoTools"
        >
          工具库
        </div>
        <div
          :class="['itemName', { mobileFontSize: $isMobile }]"
          @click="gotoIndex"
        >
          首页
        </div>
      </div>
      <div class="navRight">
        <div :class="['search', { mobileFontSize: $isMobile }]">
          <input
            :class="{ mobileFontSize: $isMobile }"
            type="text"
            placeholder="请输入关键字"
          />
          <span class="iconfont iconsousuo"></span>
        </div>
        <div class="user">
          <!-- <img class="headImg" src="../assets/images/Christmas.png" /> -->
          <p class="userName">测试版</p>
          <span class="iconfont iconshezhi"></span>
        </div>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="mobileNav" v-else>
              <div class="top">
        <img
          class="mobileLogo"
          src="../assets/images/SketchPng11fca02555aeade34b61963e863c57ab456af8d0ed7c5cdef5352c11a1f8bf22.jpg"
        />
        <span class="span"  style="font-weight:bold;width: 80px;height: 16px;font-size: 16px ">职卫工具箱

        </span>
      </div>

      <!-- <div class="user">
        <p class="userName">测试版</p>

        <div class="el-icon-s-unfold" @click="showDiabox = !showDiabox">
          <div class="div-diabox" v-show="showDiabox">
            <span class="arrow-top-out"></span>
            <div class="arrow-top-in"></div>
            <div class="hideMenu" @click="gotoTools">工具库</div>
            <div class="hideMenu">首页</div>
            <div class="hideMenu">退出登录</div>
          </div>
        </div>
      </div> -->
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      value: "",
      activeIndex: "1",
      showDiabox: false,
    };
  },
  created() {},
  methods: {
    handleSelect() {},
    gotoJKQY() {
      const curUrl = window.location.href;

      window.location.href = curUrl.replace("tools", "www");
    },
    gotoTools() {
      this.$router.push({
        name: "indexSub",
      });
    },
    gotoIndex() {
      //this.$router.push({name:"indexSub"})
    },
    onClickDisabled() {},
    onSearch() {},
  },
};
</script>

<style scoped="scoped">
@import url("../assets/iconfont.css");
.hideMenu {
  color: white;
  margin-bottom: 1rem;
  font-size: 0.5rem !important;
}
.div-diabox {
  width: 3.375rem;
  text-align: left;
  border-style: solid;
  border-width: 1px;
  border-radius: 6px;
  border-color: #797979;
  background-color: #797979;
  position: absolute;
  margin: 0 auto;
  font-size: 0.5rem !important;
  /* padding: 50px 10px; */
  padding: 0.375rem;
  padding-top: 0.8rem;
  top: 20px;
  right: -0.375rem;
  /* right: 20px; */
}

.el-icon-s-unfold {
  position: relative;
  color: white;
  font-size: 16px;
}

.div-diabox .arrow-top-out {
  width: 0px;
  height: 0px;
  border-style: solid;
  border-color: transparent transparent #797979 transparent;
  border-width: 6px;
  position: absolute;
  top: -12px;
  right: 10px;
}

.div-diabox .arrow-top-in {
  width: 0px;
  height: 0px;
  border-style: solid;
  border-color: transparent transparent #797979 transparent;
  border-width: 6px;
  position: absolute;
  top: -12px;
  right: 10px;
}

.mobileNav {
  display: flex;
  align-items: center;
  position: relative;
  margin: 2.25rem 0rem 0.5rem 0.25rem ;
  
  /* margin-bottom: 0.35rem;
  border-bottom: 2px solid #dddddd; */
  /* background: white; */
  color: white;
    flex-wrap: wrap;
  justify-content: space-between;

}

.logo {
  vertical-align: middle;
  width: 13rem;
  height: 3.5rem;
  object-fit: contain;
}
.mobileLogo {
  width: 27px;
  height: 28px;
  margin-left: 0.5rem;
}

.toolNav {
  color: #00bfff;
}

.nav {
  margin-bottom: 0.9375rem;
  border-bottom: 2px solid #dddddd;
  position: relative;
  background: #409eff;
  color: white;
}

.index {
  width: 98%;
  margin: 0 auto;
}

.nav,
.search {
  align-items: center;
  display: flex;
}

.navLeft {
  align-items: center;
  display: flex;
  color: white;
}

.navRight {
  align-items: center;
  display: flex;
  position: absolute;
  right: 0;
}

.search {
  border: 1px solid #ddd;
  border-radius: 0.9375rem;
  padding: 0.25rem;
}

.search input {
  padding: 0.1125rem;
  outline: none;
  border: none;
  font-size: 13px;
  -webkit-border-end-width: 12.5rem;
  width: 6rem;
  background: none;
}

.iconsousuo {
  cursor: pointer;
}

.itemName {
  cursor: pointer;
  padding: 1.25rem;
  font-size: 14.5px;
}

.itemName:hover {
  color: #00bfff;
}

.user {
  display: flex;
  align-items: center;
  border: none !important;
  margin-left: 3rem;
}

.userMobile {
  display: flex;
  align-items: center;
  border: none !important;
}

.userName {
  color: white;
  margin-right: 1.875rem;
  font-size: 13px;
}

/* .headImg {
    object-fit: contain;
    height: 2rem !important;
    width: 2rem;
    border-radius: 50%;
    border: 1px solid #eee;
    margin-right: 0.625rem;
  } */
.span {
  color: rgba(85, 85, 85, 1);
  font-size: 1.1rem;
  text-align: center;
  display: block;
  float: right;
  margin-top: 0.25rem;
  margin-left: 0.5rem;
}
.top{
  text-align: center;
  margin-left: 7px;
}
.el-button{
  line-height: 0.01;
  border: 0.1px solid #DCDFE6;
  padding: 5px 19px;
    font-size: 14px;
    border-radius: 5px;

}
.appCard {
  transition: all ease 1s;
  width: 11.5rem;
  height: 6.79rem;
  margin:0.4rem 0.2rem;
    border-radius:0.4rem;
    position: relative;
    background: #0063E0;
}


</style>



// WEBPACK FOOTER //
// src/components/index.vue